import EntityCard from '@/components/EntityCard';
import Typography from '@/components/ui/typography';
import { Course, CourseCategory } from '@/types';

type CourseDetail = Pick<
  Course,
  | 'title'
  | 'slug'
  | 'description'
  | 'image_url'
  | 'rating_count'
  | 'review_count'
>;

const CourseCard = ({
  category,
  course,
  categoryLabel,
}: {
  category: Pick<CourseCategory<unknown>, 'slug'>;
  course: CourseDetail;
  /** Shown as the card's eyebrow where the surrounding section isn't already
   *  scoped to one category — the home page's featured rail, for instance. */
  categoryLabel?: string;
}) => {
  // aspect 16:9 rather than the 4:3 default: in a four-up rail the taller crop
  // left the image occupying more of the card than the course name.
  return (
    <EntityCard
      href={route('courses.showCourse', {
        categorySlug: category.slug,
        courseSlug: course.slug,
      })}
      aspect="video"
      image={course.image_url}
      alt={course.title}
      eyebrow={
        categoryLabel ? (
          <Typography.Small className="font-semibold uppercase tracking-[0.14em] text-primary-text">
            {categoryLabel}
          </Typography.Small>
        ) : undefined
      }
      title={course.title}
      description={course.description}
    />
  );
};

export default CourseCard;
